var render = function render(){var _vm=this,_c=_vm._self._c;return _c('live-tutorial-form',{attrs:{"loading":_vm.loading,"live-tutorial":_vm.liveTutorial},on:{"submit":_vm.submit}})
}
var staticRenderFns = []

export { render, staticRenderFns }